import { render, staticRenderFns } from "./BrListSection.vue?vue&type=template&id=f1a38fa4&"
import script from "./BrListSection.vue?vue&type=script&lang=js&"
export * from "./BrListSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports